// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__qvva7","footer":"ModalFilter_footer__OqPHk"};